import { action } from '@ember/object';
import { service } from '@ember/service';
import Component from '@glimmer/component';
import { tracked } from '@glimmer/tracking';

export default class ListWorkstreamsBadgeComponent extends Component {
  @service store;

  @tracked showWorkstreamModal = false;

  get value() {
    return this.args.value ?? undefined;
  }

  get initiativeRecord() {
    return this.store.peekRecord('initiative', this.args.initiative);
  }

  @action
  onWorkstreamSelect(workstream) {
    this.args?.onSelect?.(workstream);
  }

  @action
  handleAddWorkstream() {
    this.showWorkstreamModal = true;
  }

  @action
  handleWorkstreamSaved(workstream) {
    this.showWorkstreamModal = false;
    this.args?.onSelect?.(workstream);
  }

  @action
  closeWorkstreamModal() {
    this.showWorkstreamModal = false;
  }
}
